import React, { useState, useEffect, useContext } from "react";
import { AuthContext } from "./AuthContext"; // Adjust path if needed

import axios from "../axios";
import "./Footer.css"; 

const Footer = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });
  const { isAuthenticated } = useContext(AuthContext);

  const [pages, setPages] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);

  const currentYear = new Date().getFullYear();

  // Fetch dynamic links from the API
  useEffect(() => {
    axios.get(`${process.env.REACT_APP_API_URL}api/pages/`)

      .then((response) => setPages(response.data))
      .catch((error) => console.error("Error fetching pages:", error));
  }, []);

  // Handle input change
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    setSuccess(false);

    try {
      await axios.post(`${process.env.REACT_APP_API_URL}api/inquiries/`, formData, {
        headers: {
          "Content-Type": "application/json",
        },
      });

      setSuccess(true);

      // ✅ Reset ALL form fields after successful submission
      setFormData({ name: "", email: "", phone: "", message: "" });

      // ✅ Automatically hide success message after 3 seconds
      setTimeout(() => {
        setSuccess(false);
      }, 3000);

    } catch (error) {
      setError("Failed to submit inquiry. Please try again.");
      console.error("Error submitting inquiry:", error);
    } finally {
      setLoading(false);
    }
  };

  // ✅ Force page reload when clicking Home
  const handleHomeClick = (event) => {
    event.preventDefault();
    window.location.href = isAuthenticated ? "/landing" : "/";
  };

  
  return (
    <footer className="footer">
      <div className="footer-container">
        {/* Inquiry Form */}
        <div className="footer-form">
          <h3>Quick Inquiry</h3>
          <form onSubmit={handleSubmit}>
            {/* Name Field */}
            <input
              type="text"
              name="name"
              placeholder="Your Name"
              value={formData.name}
              onChange={handleChange}
              required
            />

            {/* Email Field */}
            <input
              type="email"
              name="email"
              placeholder="Your Email"
              value={formData.email}
              onChange={handleChange}
              required
            />

            {/* ✅ Phone Number Field */}
            <input
              type="tel"
              name="phone"
              placeholder="Your Phone Number"
              value={formData.phone}
              onChange={handleChange}
              required
              pattern="[0-9]{10}" // ✅ Restricts input to 10-digit phone numbers
              title="Enter a 10-digit phone number"
            />

            {/* Message Field */}
            <textarea
              name="message"
              placeholder="Your Message"
              value={formData.message}
              onChange={handleChange}
              required
            />

            {/* Submit Button */}
            <button type="submit" disabled={loading}>
              {loading ? "Submitting..." : "Submit"}
            </button>
          </form>

          {/* Show success or error messages */}
          {success && <p className="success-message">Inquiry submitted successfully!</p>}
          {error && <p className="error-message">{error}</p>}
        </div>

        {/* Useful Links */}
        <div className="footer-links">
          <h3>Useful Links</h3>
          <ul>
            <li>
              <a href="/" onClick={handleHomeClick}>Home</a> {/* ✅ Reload Home on Click */}
            </li>
            {pages.map((page) => (
              <li key={page.id}>
                <a href={`/pages/${page.slug}`}>{page.title}</a>
              </li>
            ))}
          </ul>
        </div>
      </div>

      {/* ✅ ULTRA COMPACT 2-LINE FOOTER */}
      <div className="footer-bottom">
        <p>CMA T.P.Thangaprabhu B.Sc., MBA., CIMA ADV DIP MA (UK), FCMA., ACPIFSD (IIT-Roorkee) • Cost Accountant | Full Stack Developer & Data Scientist | Certified Independent Director | Director, MY727INFOTECH INDIA PRIVATE LIMITED • Contact: 99430 07270 / 98430 27787</p>
        <p>© {currentYear} MY727INFOTECH INDIA PRIVATE LIMITED | All Rights Reserved</p>
      </div>

    </footer>
  );
};

export default Footer;